import React from 'react';
import { Slide } from 'react-reveal';
import { connect } from 'react-redux';
import style from './style.module.scss';
import { ItemTypes } from '../../../Constants';
import { paramsToObject } from '../../../Utils';
import { ItemCell } from '../../';
import PropTypes from 'prop-types';

const RecipeSection = ({
    recipes = [],
    loading
}) => {

    const Header = () => {
        return (
            <Slide bottom>
                <div className={style.headerWrapper}>
                    <h1>DELICIOUS RECIPES</h1>
                    <p>Click image to view recipe instructions</p>
                </div>
            </Slide>
        )
    }

    const RelatedRecipes = () => {
        return (
            <div className={style.relatedRecipesWrapper}>
                {
                    recipes.map((r) => {
                        return (
                            <Slide bottom>
                                <ItemCell color="white" data={r} itemType={ItemTypes.recipe} />
                            </Slide>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <div className={style.wrapper}>
            <Header />
            <RelatedRecipes />
        </div>
    );
};

RecipeSection.propTypes = {
    loading: PropTypes.bool,
    recipes: PropTypes.array
};

export default connect(({ recipes, getRecipesLoading }) => {
    // Get the query params...
    const params = window.location.search ? paramsToObject(window.location.search) : {};

    // Create a new recipesRef...
    let relatedRecipes = [...recipes];

    // If params.id exists, get all recipes that match that product...
    if (params.id) relatedRecipes = recipes.filter(r => r.products_id === +params.id)
    return {
        loading: getRecipesLoading,
        recipes: relatedRecipes
    }
})(RecipeSection);